import WeatherIcon from '../WeatherIcon/WeatherIcon';

const HourlyForecast = ({ todayData, tempRange }) => {
    if (!todayData) return null;

    return (
        <div className='todayDiv roundBox'>
            {todayData.map((item) => (
                <div className='todayItemDiv' key={item.time}>
                    <div>
                        <label>{item.time}시</label><br />
                        <WeatherIcon name={item.icon} size={32} /><br />
                        <label className={
                            tempRange.low === item.temp ? "blueCor"
                                : tempRange.max === item.temp ? "redCor" : ""
                        }>
                            {item.temp}<label className='topTxt'>o</label>
                        </label><br />
                        <label>{item.rainRate}<label className='topTxt'>%</label></label>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default HourlyForecast;
